/** Yasuo AbilitySpec seed kit (wiki residual numeric align). */
export const YASUO_ABILITY_DEFS = [
  {
    id: 'yasuo_q',
    champKey: 'yasuo',
    slot: 'Q',
    name: 'Steel Tempest',
    targeting: 'skillshot_line',
    range: 450,
    castTime: 0.35,
    travelSpeed: 1200,
    width: 80,
    radius: 40,
    cooldown: 4,
    manaCost: 0,
    costType: 'flow',
    vfxId: 'yasuo_q',
    status: 'wired'
  },
  {
    id: 'yasuo_w',
    champKey: 'yasuo',
    slot: 'W',
    name: 'Wind Wall',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: 350,
    radius: null,
    cooldown: 30,
    duration: 4,
    manaCost: 0,
    costType: 'flow',
    vfxId: 'yasuo_w',
    status: 'wired'
  },
  {
    id: 'yasuo_e',
    champKey: 'yasuo',
    slot: 'E',
    name: 'Sweeping Blade',
    targeting: 'dash',
    range: 475,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 0.5,
    manaCost: 0,
    costType: 'flow',
    vfxId: 'yasuo_e',
    status: 'wired'
  },
  {
    id: 'yasuo_r',
    champKey: 'yasuo',
    slot: 'R',
    name: 'Last Breath',
    targeting: 'targeted',
    range: 1400,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 70,
    manaCost: 0,
    costType: 'flow',
    vfxId: 'yasuo_r',
    status: 'wired'
  }
];
